import { memo } from 'react'

import { StatusBadge } from '@mangovoice/mango-ui'

import { type HospitalityRoomStatus } from '../../constants/roomStatuses'
import { useHotelsI18n } from '../../i18n'
import { getRoomStatusConfig } from '../../utils/statusHelpers'
import { getRoomStatusLabel } from './roomStatusLabels'

interface RoomStatusBadgeProps {
  status: HospitalityRoomStatus
}

export const RoomStatusBadge = memo(function RoomStatusBadge({
  status,
}: RoomStatusBadgeProps) {
  const { t } = useHotelsI18n()
  const config = getRoomStatusConfig(status)

  return (
    <StatusBadge
      status={status}
      config={{
        [status]: {
          label: getRoomStatusLabel(status, t),
          colorPalette: config.colorPalette,
        },
      }}
    />
  )
})
